<template>
<div>
<select v-model="selected" class="select w10_5em" @input="updateValue">
  <option value="0">選択して下さい</option>
  <option v-for="option in options" :key=option.id v-bind:value="option.id">
    {{ option.manufacturer_name }}
  </option>
</select>
</div>
</template>

<script>
import manufacturersApi from '../store/Api/manufacturers'

export default {
  data () {
    return {
      selected: 0,
      options: {
        id: 0,
        manufacturer_name: ''
      }
    }
  },
  methods: {
    updateValue (e) {
      const value = e.target.selectedOptions.length ? e.target.selectedOptions[0]._value : null
      this.$emit('input', value)
      this.$emit('selected', value)
    }
  },
  async created () {
    await manufacturersApi.get().then(res => {
      this.options = res.data.manufacturer
    })
    this.selected = this.value
  },
  props: {
    value: {
      type: Number
    }
  }
}
</script>
